import { QueryHookOptions, useQuery } from '@apollo/client';

import { GetEljurOAuthLinkQuery } from '@modules/eljur/graphql';

import type {
    GetEljurOAuthLinkQueryType,
    GetEljurOAuthLinkQueryVariables,
} from '@modules/types/graphql';

const useEljurOAuthLink = (
    options?: QueryHookOptions<GetEljurOAuthLinkQueryType, GetEljurOAuthLinkQueryVariables>,
) => {
    const defaultOptions = {
        onCompleted: (data: { getEljurOAuthLink: string }) => {
            window.location.href = data.getEljurOAuthLink;
        },
    };

    const queryResult = useQuery<GetEljurOAuthLinkQueryType, GetEljurOAuthLinkQueryVariables>(
        GetEljurOAuthLinkQuery,
        Object.assign(defaultOptions, options),
    );

    const eljurOAuthLink = queryResult?.data?.getEljurOAuthLink ?? undefined;

    const result = {
        eljurOAuthLink,
        ...queryResult,
    };

    return result;
};

export { useEljurOAuthLink };
